<script lang="ts" context="module">
  export type ResultsData = {
    correct: string[];
    incorrect: string[];
  }

  export type NewGameCallback = () => void;
</script>

<script lang="ts">
  export let results: ResultsData;
  export let newGameCallback: NewGameCallback;
</script>

<h1>Results: {results.correct.length}</h1>

<div class="sidebyside">
  <div><h2>Correct</h2>
    <ul>
      {#each results.correct as answer}
      <li>{answer}</li>
      {/each}
    </ul>
  </div>
  <div><h2>Incorrect</h2>
    <ul>
      {#each results.incorrect as answer}
      <li>{answer}</li>
      {/each}
    </ul>   
  </div>
</div>

<button on:click={newGameCallback}>New Game</button>

<style>
  .sidebyside {
    display:flex;
    flex-flow:  row nowrap;
    justify-content: center;
    gap: 20px;
  }
  button {
    width: 200px;
    margin: auto;
  }
</style>